'use client';
import { publicRoutes, routes } from '@/app/routes';
import useUser from '@/shared/hooks/useUser';
import { redirect, usePathname } from 'next/navigation';
import { ReactNode } from 'react';

interface AuthProtectionProps {
  children?: ReactNode;
}
const AuthProtection = ({ children }: AuthProtectionProps) => {
  const { isLoggedIn } = useUser();
  const pathname = usePathname();

  // Public Pages
  if (publicRoutes.includes(pathname)) {
    return children;
  } else {
    // Protected Pages? (requiring authentication) - All Pages are protected by default
    if (isLoggedIn) {
      return children;
    } else {
      const redirectParams =
        pathname === routes.home ? '' : `?redirect=${encodeURIComponent(pathname)}`;
      return redirect(`${routes.login}${redirectParams}`);
    }
  }
};

export default AuthProtection;
